import { useRef as l } from "react";
import { useWrapElement as i, useForkRef as m } from "../../../ariakit-react-utils/esm/hooks.js";
import { createHook as g, createComponent as F, createElement as b } from "../../../ariakit-react-utils/esm/system.js";
import { getAllTabbableIn as d } from "../../../ariakit-utils/esm/focus.js";
import { FocusTrap as T } from "./focus-trap.js";
import { jsxs as R, Fragment as h, jsx as E } from "react/jsx-runtime";
const x = g((n) => {
  let {
    enabled: r = !1,
    ...e
  } = n;
  const u = l(null);
  return e = i(e, (p) => {
    const a = () => r ? /* @__PURE__ */ E(T, {
      onFocus: (f) => {
        const s = u.current;
        if (!s) return;
        const o = d(s, !0), t = o[0], c = o[o.length - 1];
        if (!o.length) {
          s.focus();
          return;
        }
        f.relatedTarget === t ? c == null || c.focus() : t == null || t.focus();
      }
    }) : null;
    return /* @__PURE__ */ R(h, {
      children: [a(), p, a()]
    });
  }, [r]), e = {
    ...e,
    ref: m(u, e.ref)
  }, e;
}), N = F((n) => {
  const r = x(n);
  return b("div", r);
});
process.env.NODE_ENV !== "production" && (N.displayName = "FocusTrapRegion");
export {
  N as FocusTrapRegion,
  x as useFocusTrapRegion
};
//# sourceMappingURL=focus-trap-region.js.map
